class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const detailsElement = drawer.querySelector('details');
    if (detailsElement && detailsElement.hasAttribute('open')) {
      return;
    }

    drawer.openMenuDrawer();
  }

  potre() {
  console.log('Potre Fired!');
  var cartUpdates = {};
  var variantId = 41254878019697;


  cartUpdates[variantId] = 1;
  var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');

    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
      
      }
    };  
    var params = JSON.stringify({ updates: cartUpdates });
    xhr.send(params);
};

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();

    requestAnimationFrame(() => {
      const cartList = document.querySelector('.mini-cart__navigation');
      if (cartList) {
        const items = Array.from(cartList.children);
        items.reverse().forEach(item => cartList.appendChild(item));
      }
      const cartMain = document.querySelector('.mini-cart__main');
      if (cartMain) cartMain.scrollTop = 0;
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return el ? el.innerHTML : '';
  }
}

customElements.define('mini-cart', MiniCart);
